import React, { useRef } from "react";
import { Link } from "gatsby";

/**
 * Render a generic navigation list
 * with links and submenus
 *
 * @param props.items structured navigation data
 * @returns
 */

function NavTree({ items, ariaLabel="Site Navigation"}) {
	// sort items by weight property
	items.sort((a, b) => {
		if (a.weight < b.weight) {
			return -1;
		}
		if (a.weight > b.weight) {
			return 1;
		}
		return 0;
	});

	if (items.length > 0) {
		return (
			<nav aria-label={ariaLabel}>
				<ul>
					{items.map((item) => (
						<NavBranch key={item.title} item={item} />
					))}
				</ul>
			</nav>
		);
	} else {
		return null;
	}
}

function NavBranch({ item }) {
	const firstSubmenuLinkRef = useRef(null);

	let children = item.children ? (
		<ul className="submenu">
			{item.children.map((c, i) => (
				<NavBranch
					key={c.title}
					item={c}
					linkRef={i === 0 ? firstSubmenuLinkRef : null}
				/>
			))}
		</ul>
	) : null;

	let Anchor = () => {
		const to = item.path ? item.path : "#";
		const is_external = to.includes("http");
		if (is_external || !item.path) {
			let link_attrs = {};
			if (is_external) {
				link_attrs = {
					target: "_blank",
					rel: "noopener noreferrer",
				};
			}
			return (
				<a href={to} {...link_attrs} ref={firstSubmenuLinkRef} tabIndex={0}>
					{item.title}
				</a>
			);
		} else if (item.path) {
			return (
				<Link to={item.path} ref={firstSubmenuLinkRef} tabIndex={0}>
					{item.title}
				</Link>
			);
		}
	};

	return (
		<li
			className={`${children !== null ? "has-submenu" : ""} ${!item.path && "void-link"}`}
			tabIndex={-1}
		>
			<Anchor />
			{children}
		</li>
	);
}

export default NavTree;
